(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('GiftcardStatementDialogController', GiftcardStatementDialogController);

    GiftcardStatementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GiftcardStatement', 'GcSystem', 'Sistema'];

    function GiftcardStatementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GiftcardStatement, GcSystem, Sistema) {
        var vm = this;

        vm.giftcardStatement = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.gcsystems = GcSystem.query();
        vm.sistemas = Sistema.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.giftcardStatement.id !== null) {
                GiftcardStatement.update(vm.giftcardStatement, onSaveSuccess, onSaveError);
            } else {
                GiftcardStatement.save(vm.giftcardStatement, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('doctorclubboApp:giftcardStatementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dtIns = false;
        vm.datePickerOpenStatus.gcExpirationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
